import { centralizedAuth as CentralizedAuth } from '@cimpress/simple-auth-wrapper';
import NotificationsHubAuthorizer from '@cimpress-technology/notifications-hub-authorizer';
import { BASENAME, isProduction } from '../utilities/processFunctions';

export const CLIENT_ID = 'iO86tEFVLEA9jGaHiTKmUJfdJ6Ygcj0a';

const auth = new CentralizedAuth({
  clientID: CLIENT_ID,
  redirectRoute: BASENAME
});

const login = () => auth.login(BASENAME);

const logout = () => auth.logout(BASENAME);

const notificationsHubAuthorizer = new NotificationsHubAuthorizer({
  env: isProduction ? 'prd' : 'int',
  centralizedAuth: auth
});

export { auth, notificationsHubAuthorizer, login, logout };
